import React from 'react'
import styles from '../LinkBox.module.css'

function LinkBox({item}) {
    return (
        <div>
            <a className={styles.linkBox + " linkBox"} href={item.url}>
                <h2 className={styles.linkBoxTitle}>{item.title}</h2>
                <p className={styles.linkBoxDescription}>{item.description}</p>
            </a>            
        </div>
    )
}

export default LinkBox
